import styled from 'astroturf/react';

/**
 * Shared loading placeholder for the LISWP hero blocks. Holds layout space
 * while an async slot (views / downloads / bulk-download CTA) resolves, so the
 * resolved content fills in place instead of flashing in and shifting the row.
 * It renders during SSR too (the initial loading state), reserving the space
 * from first paint. Each hero extends this with the slot's concrete size.
 */
export const Shimmer = styled.div`
  @keyframes liswp-hero-shimmer {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.2;
    }
  }

  border-radius: var(--border-radius-radius-sm, 4px);
  background: var(--brand-colors-neutral-300, #e3e3e8);
  animation: liswp-hero-shimmer 1.2s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
